module.exports = __webpack_public_path__ + "static/media/fx-bco.6bda82a9.svg";